import React, { useState } from "react";
import { useAtelierStore } from "@store/atelierStore";
import { WorkCharge } from "../../types/garage/atelier";

export function SplitModal({
  charge,
  onClose,
}: {
  charge: WorkCharge;
  onClose: () => void;
}) {
  const splitCharge = useAtelierStore((s) => s.splitCharge);
  const [splitValue, setSplitValue] = useState(
    Math.floor((charge.hours / 2) * 4) / 4,
  );
  const maxVal = +(charge.hours - 0.25).toFixed(2);
  const remainder = +(charge.hours - splitValue).toFixed(2);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.3)" }}
      onClick={onClose}
    >
      <div
        className="flex flex-col bg-white rounded-xl shadow-xl"
        style={{ width: 320, padding: 20, gap: 16 }}
        onClick={(e) => e.stopPropagation()}
      >
        <span
          className="text-sm font-bold"
          style={{ fontFamily: "Poppins", color: "#000" }}
        >
          Découper la charge
        </span>
        <span
          className="text-h4 font-medium"
          style={{ fontFamily: "Poppins", color: "#737373" }}
        >
          {charge.clientName} — {charge.hours}h au total
        </span>
        <div className="flex flex-col" style={{ gap: 8 }}>
          <input
            type="range"
            min={0.25}
            max={maxVal}
            step={0.25}
            value={splitValue}
            onChange={(e) => setSplitValue(parseFloat(e.target.value))}
            className="w-full"
            style={{ accentColor: "#6366F1" }}
          />
          <div className="flex flex-row justify-between">
            <div className="flex flex-col items-center" style={{ gap: 2 }}>
              <span
                className="text-h4 font-bold"
                style={{ fontFamily: "Poppins", color: "#6366F1" }}
              >
                {splitValue}h
              </span>
              <span
                className="text-h4 font-medium"
                style={{ fontFamily: "Poppins", color: "#A1A1A1" }}
              >
                Partie 1
              </span>
            </div>
            <div className="flex flex-col items-center" style={{ gap: 2 }}>
              <span
                className="text-h4 font-bold"
                style={{ fontFamily: "Poppins", color: "#8258FF" }}
              >
                {remainder}h
              </span>
              <span
                className="text-h4 font-medium"
                style={{ fontFamily: "Poppins", color: "#A1A1A1" }}
              >
                Partie 2
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-end" style={{ gap: 8 }}>
          <button
            onClick={onClose}
            className="text-h4 font-medium"
            style={{
              fontFamily: "Poppins",
              color: "#A1A1A1",
              padding: "6px 12px",
              borderRadius: 8,
              border: "1px solid #D9D9D9",
            }}
          >
            Annuler
          </button>
          <button
            onClick={() => {
              splitCharge(charge.id, splitValue);
              onClose();
            }}
            className="text-h4 font-medium"
            style={{
              fontFamily: "Poppins",
              color: "#FFF",
              background: "#6366F1",
              padding: "6px 12px",
              borderRadius: 8,
            }}
          >
            Découper
          </button>
        </div>
      </div>
    </div>
  );
}
